(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .constant('addMemberResolver', {
            member: getMemberInit,
            isLegacy: getIsLegacy,
            clubHoleType: getClubHoleType
        });

    getMemberInit.$inject = ['$transition$', '$q', 'gender', 'cultureName', 'clubMembershipLevelType', 'clubMembershipCategory', 'holeType'];
    function getMemberInit($transition$, $q, gender, cultureName, clubMembershipLevelType, clubMembershipCategory, holeType) {
        var clubId = $transition$.params().clubId,
            clubHoleType = getClubHoleType($transition$, holeType),
            defaultMemberHoleType = clubHoleType === holeType.NineHole ? holeType.NineHole : holeType.EighteenHole;

        if (!clubId)
            return $q.reject();

        return {
            id: null,
            cardId: null,
            clubId: clubId,
            firstName: null,
            lastName: null,
            email: null,
            birthDate: null,
            category: clubMembershipCategory.Men,
            gender: gender.Male,
            culture: cultureName.en_CA,
            level: clubMembershipLevelType.Gold,
            holeType: defaultMemberHoleType
        };
    }

    getIsLegacy.$inject = ['$transition$'];
    function getIsLegacy($transition$) {
        var club = $transition$.params().club;
        return club && club.isLegacy || false;
    }

    getClubHoleType.$inject = ['$transition$', 'holeType'];
    function getClubHoleType($transition$, holeType) {
        var club = $transition$.params().club;
        return club && club.holeType || holeType.EighteenHoles;
    }
})();